import React from 'react';
import { Button, Flex } from '@highereducation/hen-ui';

export interface StepNavigationProps {
  onBack?: () => void;
  onNext: () => void;
  nextLabel: string;
  showBack?: boolean;
  isFullPageExp?: boolean;
  disabled?: boolean;
}

const StepNavigation: React.FC<StepNavigationProps> = ({
  onBack,
  onNext,
  nextLabel,
  showBack = false,
  isFullPageExp = true,
  disabled = false,
}) => {
  return (
    <Flex
      direction='row'
      justify={isFullPageExp ? 'start' : 'center'}
      align='start'
      gap='xs'
      className={
        isFullPageExp
          ? 'de-cta-container fixed bottom-0 left-0 right-0 z-50 bg-neutral-50  px-5 py-4 md:static md:bg-transparent md:px-0 md:py-0 md:z-auto'
          : 'de-cta-container '
      }
    >
      {showBack && (
        <Button
          data-test='back-button'
          onClick={onBack}
          variant='grayOutline'
          size='lg'
          iconBefore='arrow-left'
          aria-label='Back'
        />
      )}
      <Button
        data-test='cta-button'
        onClick={onNext}
        variant='primaryFill'
        size='lg'
        className={isFullPageExp ? 'flex-1 md:flex-none' : undefined}
        disabled={disabled}
      >
        {nextLabel}
      </Button>
    </Flex>
  );
};

export default StepNavigation;
